import { useHistory, useParams } from "react-router";
import { useContext } from "react";
import { useManageFeatureInstanceDetails } from "entity-app/hooks/feature-details-page";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";
import { ProjectPermissionEnum } from "constants/index";
import { FeatureTypes } from "entity-app/constants";
import BidPackageDetails from "./bid-package-details";
import FeatureHeader from "./components/bid-package-header";

function PreconstructionDetailsPage() {
  const history = useHistory();
  const { projectId, bidPackageId } = useParams() as any;
  const { tokenContents } = useContext(ProjectContext);

  const { featureInstanceData, actions } = useManageFeatureInstanceDetails(
    bidPackageId,
    FeatureTypes.BID_PACKAGE
  );

  const cannotWriteAccessOfBidPackage = isPermissionNotGrantted(
    ProjectPermissionEnum.BidPackageWrite,
    tokenContents?.role!
  );

  const goBackToList = () => {
    history.push(`/project/${projectId}/bid-packages`);
  };

  return (
    <div className="grow flex-col bg-ciq-gray-600">
      <FeatureHeader
        title="Bid Package Details"
        subTitle="Preconstruction"
        actions={actions}
        number={featureInstanceData?.number}
        headerTitle={featureInstanceData?.title}
        status={featureInstanceData?.feature_workflow_instance?.milestone_state}
        disabled={cannotWriteAccessOfBidPackage}
        goBackToList={goBackToList}
        feature="BID_PACKAGE"
      />

      <BidPackageDetails
        featureInstanceData={featureInstanceData}
        actions={actions}
        featureId={bidPackageId}
      />
    </div>
  );
}

export default PreconstructionDetailsPage;
